import { Link } from "react-router-dom";
import { ExternalLink, LogOut } from "lucide-react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { useSite } from "@/lib/content";
import ContactSection from "@/pages/admin/sections/ContactSection";
import VisitSection from "@/pages/admin/sections/VisitSection";
import ModulesSection from "@/pages/admin/sections/ModulesSection";
import GallerySection from "@/pages/admin/sections/GallerySection";
import LegalSection from "@/pages/admin/sections/LegalSection";
import SettingsSection from "@/pages/admin/sections/SettingsSection";
import RequestsSection from "@/pages/admin/sections/RequestsSection";
import NoticesSection from "@/pages/admin/sections/NoticesSection";
import EnglishSection from "@/pages/admin/sections/EnglishSection";
import TicketsSection from "@/pages/admin/sections/TicketsSection";
import VisitsSection from "@/pages/admin/sections/VisitsSection";
import StaffSection from "@/pages/admin/sections/StaffSection";

const TABS = [
  ["iletisim", "İletişim", ContactSection],
  ["ziyaret", "Ziyaret bilgileri", VisitSection],
  ["moduller", "Modüller", ModulesSection],
  ["galeri", "Galeri", GallerySection],
  ["yasal", "Yasal", LegalSection],
  ["duyurular", "Duyurular", NoticesSection],
  ["ingilizce", "İngilizce", EnglishSection],
  ["ayarlar", "Ayarlar", SettingsSection],
  ["talepler", "Talepler", RequestsSection],
  ["bilet", "Bilet & Fiyat", TicketsSection],
  ["ziyaretler", "Ziyaretler", VisitsSection],
  ["gorevliler", "Görevliler", StaffSection],
];

export default function AdminDashboard({ user, onLogout }) {
  const { isAdmin, content } = useSite();
  return (
    <div data-testid="admin-dashboard">
      <header className="bg-forest text-cream">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 py-4 flex items-center justify-between gap-4">
          <div className="flex items-center gap-3 min-w-0">
            <img src="/favicon-48.png" alt="" width="36" height="36" className="h-9 w-9" />
            <div className="min-w-0">
              <p className="font-serif text-2xl leading-none">Yönetim</p>
              <p className="text-xs text-cream/70 truncate">{user.email}</p>
            </div>
          </div>
          <div className="flex items-center gap-2">
            <Link to="/" className="inline-flex items-center gap-1.5 min-h-[44px] px-4 rounded-full text-sm font-semibold hover:bg-white/10" data-testid="admin-view-site-link">
              <ExternalLink className="h-4 w-4" aria-hidden="true" /> <span className="hidden sm:inline">Siteyi görüntüle</span>
            </Link>
            <button type="button" onClick={onLogout} className="inline-flex items-center gap-1.5 min-h-[44px] px-4 rounded-full text-sm font-semibold bg-white/10 hover:bg-white/20" data-testid="admin-logout-button">
              <LogOut className="h-4 w-4" aria-hidden="true" /> Çıkış
            </button>
          </div>
        </div>
      </header>
      <main className="max-w-6xl mx-auto px-4 sm:px-6 py-8">
        {!isAdmin || !content ? (
          <p className="py-20 text-center text-ink-muted" aria-busy="true">Yükleniyor…</p>
        ) : (
          <Tabs defaultValue="iletisim">
            <TabsList className="h-auto w-full flex-wrap justify-start bg-white border border-line rounded-2xl p-1 gap-1">
              {TABS.map(([id, label]) => (
                <TabsTrigger key={id} value={id} className="min-h-[44px] px-4 rounded-xl data-[state=active]:bg-forest data-[state=active]:text-cream" data-testid={`admin-tab-${id}`}>
                  {label}
                </TabsTrigger>
              ))}
            </TabsList>
            {TABS.map(([id, , Comp]) => (
              <TabsContent key={id} value={id} className="mt-6">
                <Comp />
              </TabsContent>
            ))}
          </Tabs>
        )}
      </main>
    </div>
  );
}
